export default "__VITE_ASSET__Cxu1ReKC__"